import { BookingStepOne } from "./components/BookingStepOne";
import { BookingStepTwo } from "./components/BookingStepTwo";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDeliveryFlowStore } from "../../store/newVehicleDeliveryStore";
import { BookingSummary } from "./components/BookingSummary";
import { DeliveryBookingStepHeader } from "./components/DeliveryBookingStepHeader";
import { DeliveryookingStepper } from "./components/DeliveryBookingStepper";
import { BookingRAC } from "./components/BookingRAC";
import { useGetShowSummary } from "../../hooks/react-query/useVehicleDelivery";
import { DeliverySlider } from "./components/DeliverySlider";
import usePersonStore from "../../store/personStore";
import { BookingAuthorized } from "./components/BookingAuthorized";

export const DeliveryPage = () => {
  // GLOBAL STATE:
  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
    );

  const uiStep = useDeliveryFlowStore((s) => s.uiStep);
  const flowId = useDeliveryFlowStore((s) => s.flowId);

  const setSummaryObject = useDeliveryFlowStore((s) => s.setSummaryObject);
  const setUiStep = useDeliveryFlowStore((s) => s.setUiStep);
  const clearPersistedCarData = useDeliveryFlowStore((s) => s.clearPersistedCarData);

  // GLOBAL STATE:
  const [ isAfterViva, setIsAfterViva ] = useState(false)

  // DATA:

  // FETCH DATA:

  // LOCAL VARIABLES:
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const isSummaryPage = location.pathname.startsWith('/vehicledelivery/summary');
  const { urlflowId } = useParams();
  const paymentStatus = searchParams.get('paymentStatus');
  const deliveryType = searchParams.get('deliveryType');

  const resolvedFlowId = React.useMemo(
    () => urlflowId ?? flowId,
    [urlflowId, flowId]
  );
  
  const isSummaryReady = uiStep === 3 && !!resolvedFlowId;

  const { data } = useGetShowSummary({ vehicleFlowId: resolvedFlowId, enabled: isSummaryReady, });

  // USE EFFECTS:
  useEffect(()=>{
    setSummaryObject(data)
  },[data, setSummaryObject])

  useEffect(()=>{
    if(isSummaryPage) {
      setIsAfterViva(!!paymentStatus)
      setUiStep(3)
    } else if(!isSummaryPage && uiStep === null) {
      navigate(showRetailDashboard ? "/dashboard" : "/portal/my-cars")
      clearPersistedCarData()
    }
  },[searchParams, isSummaryPage, setUiStep, uiStep, navigate, showRetailDashboard, clearPersistedCarData, paymentStatus])

  // HANDLERS & FUNCTIONS

  const renderStepComponent = () => {
    switch (uiStep) {
      case 1:
        return <BookingStepOne/>;
      case 2:
        return <BookingStepTwo/>;
      case 3: 
        return <BookingSummary afterViva={isAfterViva} paymentStatus={paymentStatus}/>;
      default:
        return null;
    }
  };

    const deliveryCase = () => {
    switch (deliveryType) {
      case "NEW WAY":
        return renderStepComponent();
      case "AUTHORIZED":
        return <BookingAuthorized />
      case "RAC": 
        return <BookingRAC />
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`flex flex-col max-h-screen w-full h-full min-h-0`}
      >
        {!isAfterViva && deliveryType === "NEW WAY" && uiStep !== 3 &&
          (uiStep > 0 && uiStep < 3 && (
            <DeliveryookingStepper />
          ))}

        <div className={`${deliveryType === "NEW WAY" ? "" : "pt-4"} flex flex-row max-h-screen min-h-[83vh] w-full ${(uiStep === 3) && 'justify-center'} max-sm:pb-5`}>
          {(uiStep < 3 || uiStep === 10) && <DeliverySlider />}
          <div className={`flex flex-row w-full justify-center align-middle  max-lg:px-5 lg:-ml-7`}>
            <div className='w-full flex flex-col max-h-full justify-start items-center'>
                <>
                  {deliveryType === "NEW WAY" && uiStep < 3 && <DeliveryBookingStepHeader />}
                  <div className={`flex justify-center max-w-[55vw] min-w-[55vw] max-lg:min-w-full max-xl:min-w-[652px] pb-5 h-full min-h-0`}>
                    {uiStep === 3 ? renderStepComponent() : deliveryCase()}
                  </div>
                </>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};
